<section class="client-links" [class.client-links-embedded]="embedded" *ngIf="userId">
  <button *ngIf="!embedded" class="section-trigger" type="button" [attr.aria-expanded]="expanded" [attr.aria-controls]="scope" (click)="expanded = !expanded">
    <span>Uppdragsgivarkopplingar</span><mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>
  <div [id]="scope" [hidden]="!embedded && !expanded" class="section-content">
    <p *ngIf="!embedded">Koppla ditt konto till uppdragsgivarens organisation med ditt ID där.</p>
    <div *ngIf="state.loading" aria-label="Hämtar kopplingar" aria-busy="true">
      <div class="skeleton" *ngFor="let row of [1,2,3,4,5]"></div>
    </div>
    <button *ngIf="!editing && !state.loading && state.loaded" mat-stroked-button type="button" [disabled]="state.busy" (click)="startAdd()">
      <mat-icon>add</mat-icon>Lägg till koppling
    </button>
    <div *ngIf="editing && !state.loading && state.loaded" class="editor">
      <h4>{{ editId === null ? 'Lägg till koppling' : 'Ändra koppling' }}</h4>
      <ng-container *ngIf="!organization">
      <div class="search-row">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Sök organisation</mat-label>
          <input #searchInput matInput [(ngModel)]="term" [ngModelOptions]="{standalone: true}" [disabled]="state.busy" (keydown.enter)="$event.preventDefault(); term.trim().length >= 2 && search()">
          <mat-hint>Minst två tecken i namn eller organisationsnummer.</mat-hint>
        </mat-form-field>
        <button mat-stroked-button type="button" [disabled]="state.busy || state.searching || term.trim().length < 2" (click)="search()"><mat-icon>search</mat-icon>Sök</button>
      </div>
      <p *ngIf="state.searching" role="status">Söker uppdragsgivare…</p>
      <p *ngIf="state.searchError" role="alert">{{ state.searchError }}</p>
      <p *ngIf="searched && !state.searching && !state.searchError && !state.organizations.length">Inga organisationer hittades.</p>
      <div *ngIf="searched && !state.searching && !state.searchError && state.organizations.length">
        <p role="status">Sökträffar: {{ state.organizations.length }}</p>
        <ul class="organization-results" aria-label="Organisationer som matchar sökningen">
          <li *ngFor="let item of state.organizations" class="organization-result">
            <div class="organization-details">
              <strong>{{ item.Name }}</strong>
              <p *ngIf="item.OrgNumber">{{ item.OrgNumber }}</p>
            </div>
            <button mat-stroked-button type="button" [disabled]="state.busy" [attr.aria-label]="'Välj ' + item.Name" (click)="selectOrganization(item)">Välj</button>
          </li>
        </ul>
      </div>
      </ng-container>
      <ng-container *ngIf="organization">
        <div class="selected-organization">
          <div class="organization-details">
            <strong>{{ organization.Name }}</strong>
            <p *ngIf="organization.OrgNumber">{{ organization.OrgNumber }}</p>
          </div>
          <button mat-stroked-button type="button" [disabled]="state.busy" (click)="changeOrganization()">Byt organisation</button>
        </div>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Ditt ID hos uppdragsgivaren</mat-label>
          <input #idInput matInput [(ngModel)]="externalId" [ngModelOptions]="{standalone: true}" [disabled]="state.busy" maxlength="120" required>
        </mat-form-field>
      </ng-container>
      <div class="actions">
        <button *ngIf="organization" mat-raised-button color="accent" type="button" [disabled]="state.busy || !externalId.trim()" (click)="save()">{{ state.busy ? 'Sparar…' : 'Spara koppling' }}</button>
        <button mat-stroked-button type="button" [disabled]="state.busy" (click)="reset()">Avbryt</button>
      </div>
    </div>
    <p *ngIf="!editing && state.loaded && !state.loading && !state.links.length">Inga uppdragsgivarkopplingar registrerade.</p>
    <div #linkRow class="link-row" *ngFor="let link of state.links" tabindex="-1" [attr.data-organization-id]="link.OrganizationId">
      <div>
        <strong>{{ link.OrganizationName }}</strong>
        <p>Ditt ID: {{ link.ExternalId }}</p>
        <p *ngIf="savedOrganizationId === link.OrganizationId && !state.busy && !state.error" role="status">Koppling sparad</p>
      </div>
      <div class="actions">
        <button mat-icon-button type="button" [disabled]="state.busy || state.loading" (click)="edit(link)" [attr.aria-label]="'Ändra koppling till ' + link.OrganizationName" matTooltip="Ändra"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button type="button" [disabled]="state.busy || state.loading" (click)="pendingDelete = link.Id" [attr.aria-label]="'Ta bort koppling till ' + link.OrganizationName" matTooltip="Ta bort"><mat-icon>delete</mat-icon></button>
      </div>
      <div *ngIf="pendingDelete === link.Id" class="delete-confirm">
        <p>Ta bort kopplingen till {{ link.OrganizationName }}?</p>
        <div class="actions">
          <button mat-stroked-button type="button" [disabled]="state.busy" (click)="pendingDelete = null">Avbryt</button>
          <button mat-raised-button color="warn" type="button" [disabled]="state.busy" (click)="remove(link.Id)">Ta bort</button>
        </div>
      </div>
    </div>
    <p *ngIf="state.error" role="alert">{{ state.error }}</p>
    <button *ngIf="state.error" mat-stroked-button type="button" (click)="reload()">Hämta kopplingar igen</button>
  </div>
</section>
